module.exports = __webpack_public_path__ + "static/media/crystalize.7eaab9cc.svg";